import { RouteConfig } from 'vue-router';
import NotFound from './NotFoundPage.vue';

const routes: Array<RouteConfig> = [
    { 
        path: '/404', 
        name: '404', 
        component: NotFound, 
    }, 
    { 
        path: '*',
        redirect: '/404' 
    }
];

export default routes;